import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '../stores/auth.store'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation()
  const { user, hasAccess, isInitialized } = useAuthStore()

  if (!isInitialized) {
    return <>{children}</>
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (!hasAccess) {
    return <Navigate to="/access-denied" replace />
  }

  return <>{children}</>
}
